import React from 'react';
import styled from 'styled-components';
import SmallDoughnut from '@/common/components/SmallDoughnut';
import { PillarData } from '@/areas/culture-hub/types/api';
import { PILLAR_QUESTION_MAP } from '@/common/constants/pillars';

interface MobilePillarCardProps {
  item: PillarData;
  onOpen?: (key: string) => void;
}

const MobilePillarCard: React.FC<MobilePillarCardProps> = ({ item, onOpen }) => {
  const interactive = typeof onOpen === 'function';
  const handleClick = () => {
    if (interactive) onOpen(item.key);
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!interactive) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onOpen(item.key);
    }
  };

  return (
    <Card
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={interactive ? handleClick : undefined}
      onKeyDown={interactive ? handleKeyDown : undefined}
      aria-label={interactive ? `Open pillar ${item.name}` : undefined}
    >
      <TitleRow>
        <TitleRowLeft>
          <DoughnutWrapper>
            <SmallDoughnut value={item.score} colorized size={48} />
          </DoughnutWrapper>
          <TitleBlock>
            <Title>{item.name}</Title>
            {PILLAR_QUESTION_MAP[item.name] ? (
              <QuestionText>{PILLAR_QUESTION_MAP[item.name]}</QuestionText>
            ) : null}
          </TitleBlock>
        </TitleRowLeft>
      </TitleRow>
    </Card>
  );
};

export default MobilePillarCard;

const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  min-width: 0;
`;

const TitleRowLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  flex: 1 1 auto;
  min-width: 0;
`;

const DoughnutWrapper = styled.div`
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
`;

const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
  color: #111827;
`;

const QuestionText = styled.div`
  font-size: 12px;
  color: #6b7280;
  line-height: 1.35;
`;
